<template>
    <div class="p-10">
        <template v-if="loadingCreate">
            <div class="flex justify-center items-center">
                <i class="fas fa-spinner fa-spin fa-3x"></i>
            </div>
        </template>

        <template v-if="!loadingCreate && partie">
            <div class="text-center">
                <button @click="$router.push({name: 'Home'})" class="mb-8 bg-blue-500 text-white px-4 py-2 rounded">
                    Retour à l'accueil
                </button>
                <h2 class="text-2xl font-bold mb-4">Partie créée avec succès !</h2>
                <div class="bg-slate-200 p-6 rounded-lg shadow-md inline-block mb-6">
                    <div class="mb-2">ID de la partie : <div class="tracking-wider text-3xl font-bold">{{ partie.token }}</div></div>
                </div>

                <div class="bg-orange-100 p-4 rounded-lg shadow-md mb-6">
                    <i class="fas fa-info-circle mr-2"></i>
                    Assurez-vous d'avoir votre spotify ouvert
                </div>

                <div class="mb-6">
                    <div>Liste des appareils:</div>
                    <template v-if="devices.length === 0">
                        <div class="text-gray-600 italic mt-2">Aucun appareil trouvé.</div>
                    </template>
                    <template v-if="devices.length > 0">
                        <select v-model="selectedDeviceId" class="mt-4 p-3 text-lg border rounded bg-white text-black w-full">
                            <option value="">Sélectionner un appareil</option>
                            <option v-for="device in devices" :key="device.id" :value="device.id">
                                {{ device.name }}
                            </option>
                        </select>
                    </template>
                </div>

                <div>Liste des joueurs:</div>
                <template v-if="joueurs.length === 0">
                    <div class="text-gray-600 italic mt-2">Aucun joueur n'a encore rejoint la partie.</div>
                </template>
                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-6">
                    <div v-for="joueur in joueurs" :key="joueur.id" class="bg-gradient-to-br from-slate-500 to-slate-600 rounded-lg shadow-lg p-6 text-white transform hover:scale-105 transition">
                        <div class="text-lg font-bold">{{ joueur }}</div>
                    </div>
                </div>

                <div class="mt-6">
                    <button :disabled="loadingStart" @click="startGame" class="bg-blue-500 text-white px-4 py-2 rounded">
                        <template v-if="loadingStart">
                            <i class="fas fa-spinner fa-spin"></i>
                        </template>
                        <template v-if="!loadingStart">
                            Démarrer la partie
                        </template>
                    </button>
                </div>
            </div>
        </template>

    </div>
</template>

<script>
export default {
    data() {
        return {
            partie: null,
            loadingCreate: false,

            joueurs: [],
            devices: [],

            selectedDeviceId: null,

            loadingStart: false,
        }
    },
    methods: {
        async getDevices() {
            let response = await this.$request.post('/spotify/get-devices', {
                token: localStorage.getItem('user-token')
            })
            this.devices = response.devices
        },
        async createPartie() {
            let response = await this.$request.post('/create-partie', {
                token: localStorage.getItem('user-token'),
            })
            this.partie = response

            this.$websocket.receive("join-partie-" + response.token, data => {
                this.joueurs.push(data.nom);
            });
        },

        async startGame() {
            if (!this.selectedDeviceId) {
                this.$toast.error('Veuillez sélectionner un appareil Spotify avant de créer une partie.');
                return;
            }

            this.loadingStart = true;
            let response = await this.$request.post('/start-partie', {
                partie_token: this.partie.token,
                device_id: this.selectedDeviceId
            })
            this.loadingStart = false
            if (response) {
                this.$router.push({ name: 'Game', params: { partieToken: this.partie.token } });
            } else {
                this.$toast.error('Erreur lors du démarrage de la partie.');
            }
        }
    },
    mounted () {
        this.createPartie();
        this.getDevices();

        // this.$websocket.push("first", {
        //     user: "Victor",
        //     text: "Hello Ably !"
        // });
    },
}
</script>

<style lang="scss" scoped>

</style>